const countyData = {
  Alabama: [
    'Autauga',
    'Baldwin',
    'Barbour',
    'Bullock',
    'Henry',
    'Bibb',
    'Chilton',
    'Coosa',
    'Perry',
    'Blount',
    'Butler',
    'Crenshaw',
    'Pike',
    'Calhoun',
    'Chambers',
    'Cleburne',
    'Randolph',
    'Cherokee',
    'Etowah',
    'Choctaw',
    'Clarke',
    'Washington',
    'Clay',
    'Talladega',
    'Coffee',
    'Geneva',
    'Colbert',
    'Conecuh',
    'Marengo',
    'Monroe',
    'Wilcox',
    'Covington',
    'Escambia',
    'Cullman',
    'Dale',
    'Dallas',
    'Lowndes',
    'DeKalb',
    'Elmore',
    'Fayette',
    'Lamar',
    'Marion',
    'Franklin',
    'Lawrence',
    'Greene',
    'Hale',
    'Pickens',
    'Sumter',
    'Houston',
    'Jackson',
    'Jefferson',
    'Lauderdale',
    'Lee',
    'Limestone',
    'Macon',
    'Tallapoosa',
    'Madison',
    'Marshall',
    'Mobile',
    'Montgomery',
    'Morgan',
    'Russell',
    'St. Clair',
    'Shelby',
    'Tuscaloosa',
    'Walker',
    'Winston',
  ].sort(),
  Alaska: [
    'Anchorage',
    'Fairbanks North Star',
    'Kenai Peninsula',
    'Matanuska-Susitna',
    'Northern Alaska',
    'Nome',
    'North Slope',
    'Southeast Fairbanks',
    'Valdez-Cordova',
    'Haines',
    'Juneau',
    'Petersburg',
    'Sitka',
    'Southeast Alaska',
    'Southwest Alaska',
    'Bethel',
    'Bristol Bay',
    'Dillingham',
    'Kodiak Island',
    'Southwest Alaska',
  ].sort(),
  Arizona: [
    'Apache',
    'Cochise',
    'Graham',
    'Greenlee',
    'Coconino',
    'Gila',
    'Yavapai',
    'Maricopa',
    'Mohave',
    'Navajo',
    'Pima',
    'Santa Cruz',
    'Pinal',
    'Yuma',
  ].sort(),
  Arkansas: [
    'Arkansas (county)',
    'Monroe',
    'Phillips',
    'Prairie',
    'Baxter',
    'Marion',
    'Benton',
    'Boone',
    'Carroll',
    'Madison',
    'Bradley',
    'Calhoun',
    'Cleveland',
    'Union',
    'Clark',
    'Dallas',
    'Ouachita',
    'Clay',
    'Greene',
    'Columbia',
    'Lafayette',
    'Miller',
    'Conway',
    'Pope',
    'Craighead',
    'Crawford',
    'Crittenden',
    'Cross',
    'Lee',
    'St. Francis',
    'Faulkner',
    'Franklin',
    'Johnson',
    'Logan',
    'Garland',
    'Grant',
    'Hot Spring',
    'Hempstead',
    'Howard',
    'Nevada',
    'Pike',
    'Independence',
    'Jackson',
    'Woodruff',
    'Jefferson',
    'Little River',
    'Polk',
    'Sevier',
    'Lonoke',
    'Mississippi',
    'Poinsett',
    'Montgomery',
    'Perry',
    'Scott',
    'Yell',
    'Pulaski',
    'Saline',
    'Sebastian',
    'Fulton',
    'Izard',
    'Lawrence',
    'Randolph',
    'Sharp',
    'Ashley',
    'Chicot',
    'Desha',
    'Drew',
    'Lincoln',
    'Cleburne',
    'Newton',
    'Searcy',
    'Stone',
    'Van Buren',
    'Washington',
    'White',
  ].sort(),
  California: [
    'Alameda',
    'Alpine',
    'Amador',
    'Calaveras',
    'Inyo',
    'Mono',
    'Butte',
    'Colusa',
    'Lake',
    'Contra Costa',
    'Del Norte',
    'Humboldt',
    'Trinity',
    'El Dorado',
    'Fresno',
    'Glenn',
    'Tehama',
    'Imperial',
    'Kern',
    'Kings',
    'Lassen',
    'Plumas',
    'Sierra',
    'Los Angeles',
    'Madera',
    'Marin',
    'Mariposa',
    'Tuolumne',
    'Mendocino',
    'Merced',
    'Modoc',
    'Siskiyou',
    'Monterey',
    'Napa',
    'Nevada',
    'Orange',
    'Placer',
    'Riverside',
    'Sacramento',
    'San Benito',
    'San Bernardino',
    'San Diego',
    'San Francisco',
    'San Joaquin',
    'San Luis Obispo',
    'San Mateo',
    'Santa Barbara',
    'Santa Clara',
    'Santa Cruz',
    'Shasta',
    'Solano',
    'Sonoma',
    'Stanislaus',
    'Sutter',
    'Tulare',
    'Ventura',
    'Yolo',
    'Yuba',
  ].sort(),
  Colorado: [
    'Arapahoe',
    'Chaffee',
    'Gunnison',
    'Lake',
    'Pitkin',
    'Saguache',
    'Custer',
    'Fremont',
    'Delta',
    'Montrose',
    'Denver',
    'Douglas',
    'Eagle',
    'Elbert',
    'Kit Carson',
    'Lincoln',
    'Washington',
    'Yuma',
    'El Paso',
    'Garfield',
    'Jefferson',
    'La Plata',
    'Montezuma',
    'Larimer',
    'Logan',
    'Morgan',
    'Phillips',
    'Sedgwick',
    'Mesa',
    'Grand',
    'Jackson',
    'Moffat',
    'Rio Blanco',
    'Routt',
    'Clear Creek',
    'Gilpin',
    'Park',
    'Summit',
    'Teller',
    'Pueblo',
    'Baca',
    'Bent',
    'Cheyenne',
    'Conejos',
    'Costilla',
    'Crowley',
    'Huerfano',
    'Kiowa',
    'Las Animas',
    'Otero',
    'Prowers',
    'Alamosa',
    'Archuleta',
    'Dolores',
    'Hinsdale',
    'Mineral',
    'Ouray',
    'Rio Grande',
    'San Juan',
    'San Miguel',
  ].sort(),
  Connecticut: [
    'Fairfield',
    'Hartford',
    'Litchfield',
    'Middlesex',
    'New Haven',
    'New London',
    'Tolland',
    'Windham',
  ].sort(),
  Delaware: ['Kent', 'New Castle', 'Sussex'].sort(),
  DC: ['District of Columbia'].sort(),
  Florida: [
    'Alachua',
    'Baker',
    'Bradford',
    'Union',
    'Bay',
    'Brevard',
    'Broward',
    'Charlotte',
    'Citrus',
    'Clay',
    'Collier',
    'Columbia',
    'DeSoto',
    'Hardee',
    'Dixie',
    'Gilchrist',
    'Levy',
    'Duval',
    'Escambia',
    'Flagler',
    'Gadsden',
    'Leon',
    'Glades',
    'Hendry',
    'Okeechobee',
    'Hamilton',
    'Lafayette',
    'Suwannee',
    'Hernando',
    'Highlands',
    'Hillsborough',
    'Holmes',
    'Walton',
    'Indian River',
    'Jackson',
    'Washington',
    'Jefferson',
    'Madison',
    'Taylor',
    'Lake',
    'Lee',
    'Calhoun',
    'Franklin',
    'Gulf',
    'Liberty',
    'Wakulla',
    'Manatee',
    'Marion',
    'Martin',
    'Miami-Dade',
    'Monroe',
    'Nassau',
    'Okaloosa',
    'Orange',
    'Osceola',
    'Palm Beach',
    'Pasco',
    'Pinellas',
    'Polk',
    'Putnam',
    'St. Johns',
    'St. Lucie',
    'Santa Rosa',
    'Sarasota',
    'Seminole',
    'Sumter',
    'Volusia',
  ].sort(),
  Georgia: [
    'Appling',
    'Jeff Davis',
    'Long',
    'Wayne',
    'Bacon',
    'Ben Hill',
    'Coffee',
    'Irwin',
    'Banks',
    'Habersham',
    'Barrow',
    'Bartow',
    'Bibb',
    'Bleckley',
    'Dodge',
    'Pulaski',
    'Twiggs',
    'Brantley',
    'Pierce',
    'Ware',
    'Brooks',
    'Thomas',
    'Bryan',
    'Liberty',
    'Bulloch',
    'Burke',
    'Emanuel',
    'Jenkins',
    'Screven',
    'Butts',
    'Lamar',
    'Monroe',
    'Baker',
    'Calhoun',
    'Clay',
    'Early',
    'Lee',
    'Miller',
    'Quitman',
    'Randolph',
    'Terrell',
    'Camden',
    'Charlton',
    'Candler',
    'Evans',
    'Tattnall',
    'Toombs',
    'Carroll',
    'Heard',
    'Catoosa',
    'Chatham',
    'Chattooga',
    'Dade',
    'Walker',
    'Cherokee',
    'Pickens',
    'Clarke',
    'Madison',
    'Oconee',
    'Clayton',
    'Cobb',
    'Colquitt',
    'Mitchell',
    'Columbia',
    'Coweta',
    'Crawford',
    'Peach',
    'Pike',
    'Upson',
    'Crisp',
    'Dooly',
    'Turner',
    'Wilcox',
    'Dawson',
    'Lumpkin',
    'White',
    'Decatur',
    'Grady',
    'Seminole',
    'DeKalb',
    'Dougherty',
    'Douglas',
    'Effingham',
    'Elbert',
    'Franklin',
    'Hart',
    'Stephens',
    'Fannin',
    'Rabun',
    'Towns',
    'Union',
    'Fayette',
    'Floyd',
    'Forsyth',
    'Fulton',
    'Gilmer',
    'Murray',
    'Glynn',
    'McIntosh',
    'Gordon',
    'Gwinnett',
    'Hall',
    'Hancock',
    'Jasper',
    'Morgan',
    'Putnam',
    'Haralson',
    'Polk',
    'Harris',
    'Meriwether',
    'Talbot',
    'Henry',
    'Houston',
    'Jackson',
    'Atkinson',
    'Berrien',
    'Clinch',
    'Cook',
    'Echols',
    'Lanier',
    'Lowndes',
    'Chattahoochee',
    'Macon',
    'Marion',
    'Schley',
    'Stewart',
    'Sumter',
    'Taylor',
    'Webster',
    'Muscogee',
    'Newton',
    'Paulding',
    'Richmond',
    'Rockdale',
    'Spalding',
    'Greene',
    'Lincoln',
    'McDuffie',
    'Ogelthorpe',
    'Taliaferro',
    'Warren',
    'Wilkes',
    'Tift',
    'Worth',
    'Troup',
    'Walton',
    'Baldwin',
    'Glascock',
    'Jefferson',
    'Johnson',
    'Jones',
    'Washington',
    'Wilkinson',
    'Laurens',
    'Montgomery',
    'Telfair',
    'Treutlen',
    'Wheeler',
    'Whitfield',
  ].sort(),
  Hawaii: ['Hawaii (county)', 'Honolulu', 'Kalawao', 'Maui', 'Kauai'].sort(),
  Idaho: [
    'Ada',
    'Bannock',
    'Bear Lake',
    'Caribou',
    'Franklin',
    'Benewah',
    'Latah',
    'Nez Perce',
    'Bingham',
    'Oneida',
    'Power',
    'Boise',
    'Gem',
    'Payette',
    'Washington',
    'Bonner',
    'Boundary',
    'Shoshone',
    'Bonneville',
    'Canyon',
    'Adams',
    'Clearwater',
    'Custer',
    'Idaho (county)',
    'Lemhi',
    'Lewis',
    'Valley',
    'Elmore',
    'Gooding',
    'Owyhee',
    'Butte',
    'Clark',
    'Fremont',
    'Jefferson',
    'Madison',
    'Teton',
    'Kootenai',
    'Blaine',
    'Camas',
    'Cassia',
    'Jerome',
    'Lincoln',
    'Minidoka',
    'Twin Falls',
  ].sort(),
  Illinois: [
    'Adams',
    'Bond',
    'Effingham',
    'Fayette',
    'Boone',
    'Brown',
    'Calhoun',
    'Cass',
    'Pike',
    'Schuyler',
    'Scott',
    'Bureau',
    'Marshall',
    'Putnam',
    'Stark',
    'Carroll',
    'Jo Daviess',
    'Stephenson',
    'Champaign',
    'Christian',
    'Shelby',
    'Clark',
    'Crawford',
    'Cumberland',
    'Jasper',
    'Clay',
    'Hamilton',
    'Wayne',
    'White',
    'Clinton',
    'Marion',
    'Coles',
    'Cook',
    'DeKalb',
    'De Witt',
    'Logan',
    'Mason',
    'Menard',
    'Douglas',
    'Edgar',
    'Moultrie',
    'Piatt',
    'DuPage',
    'Edwards',
    'Lawrence',
    'Richland',
    'Wabash',
    'Ford',
    'Iroquois',
    'Livingston',
    'Franklin',
    'Gallatin',
    'Saline',
    'Fulton',
    'McDonough',
    'Greene',
    'Jersey',
    'Morgan',
    'Grundy',
    'Hancock',
    'Henderson',
    'Mercer',
    'Warren',
    'Henry',
    'Jackson',
    'Jefferson',
    'Washington',
    'Kane',
    'Kankakee',
    'Kendall',
    'Knox',
    'Lake',
    'La Salle',
    'Lee',
    'Whiteside',
    'McHenry',
    'McLean',
    'Macon',
    'Macoupin',
    'Montgomery',
    'Madison',
    'Monroe',
    'St. Clair',
    'Ogle',
    'Peoria',
    'Woodford',
    'Perry',
    'Randolph',
    'Rock Island',
    'Sangamon',
    'Alexander',
    'Hardin',
    'Johnson',
    'Massac',
    'Pope',
    'Pulaski',
    'Union',
    'Tazewell',
    'Vermilion',
    'Will',
    'Williamson',
    'Winnebago',
  ].sort(),
  Indiana: [
    'Adams',
    'Wells',
    'Allen',
    'Bartholomew',
    'Brown',
    'Benton',
    'Jasper',
    'Newton',
    'Blackford',
    'Jay',
    'Randolph',
    'Boone',
    'Carroll',
    'Clinton',
    'Cass',
    'White',
    'Clark',
    'Scott',
    'Clay',
    'Sullivan',
    'Vermillion',
    'Vigo',
    'Crawford',
    'Harrison',
    'Perry',
    'Daviess',
    'Knox',
    'Martin',
    'Dearborn',
    'Ohio',
    'Ripley',
    'Switzerland',
    'Decatur',
    'Shelby',
    'DeKalb',
    'Steuben',
    'Delaware',
    'Dubois',
    'Pike',
    'Spencer',
    'Elkhart',
    'Fayette',
    'Franklin',
    'Union',
    'Floyd',
    'Fountain',
    'Montgomery',
    'Warren',
    'Fulton',
    'Miami',
    'Wabash',
    'Gibson',
    'Posey',
    'Grant',
    'Greene',
    'Owen',
    'Parke',
    'Putnam',
    'Hamilton',
    'Hancock',
    'Hendricks',
    'Henry',
    'Rush',
    'Howard',
    'Tipton',
    'Huntington',
    'Whitley',
    'Jackson',
    'Washington',
    'Jefferson',
    'Jennings',
    'Johnson',
    'Kosciusko',
    'LaGrange',
    'Noble',
    'Lake',
    'LaPorte',
    'Lawrence',
    'Orange',
    'Madison',
    'Marion',
    'Marshall',
    'Pulaski',
    'Starke',
    'Monroe',
    'Morgan',
    'Porter',
    'St. Joseph',
    'Tippecanoe',
    'Vanderburgh',
    'Warrick',
    'Wayne',
  ].sort(),
  Iowa: [
    'Allamakee',
    'Clayton',
    'Winneshiek',
    'Adair',
    'Audubon',
    'Cass',
    'Guthrie',
    'Shelby',
    'Benton',
    'Iowa (county)',
    'Keokuk',
    'Washington',
    'Black Hawk',
    'Boone',
    'Carroll',
    'Greene',
    'Bremer',
    'Butler',
    'Grundy',
    'Buchanan',
    'Delaware',
    'Fayette',
    'Cedar',
    'Clinton',
    'Jackson',
    'Jones',
    'Cerro Gordo',
    'Hancock',
    'Winnebago',
    'Dallas',
    'Davis',
    'Jefferson',
    'Van Buren',
    'Wapello',
    'Des Moines',
    'Henry',
    'Lee',
    'Dubuque',
    'Franklin',
    'Hamilton',
    'Hardin',
    'Wright',
    'Fremont',
    'Harrison',
    'Mills',
    'Pottawattamie',
    'Jasper',
    'Poweshiek',
    'Johnson',
    'Linn',
    'Louisa',
    'Muscatine',
    'Appanoose',
    'Clarke',
    'Decatur',
    'Lucas',
    'Monroe',
    'Wayne',
    'Lyon',
    'O`Brien',
    'Osceola',
    'Sioux',
    'Madison',
    'Warren',
    'Mahaska',
    'Marion',
    'Marshall',
    'Tama',
    'Chickasaw',
    'Floyd',
    'Howard',
    'Mitchell',
    'Worth',
    'Clay',
    'Dickinson',
    'Emmet',
    'Kossuth',
    'Palo Alto',
    'Buena Vista',
    'Calhoun',
    'Humboldt',
    'Pocahontas',
    'Sac',
    'Webster',
    'Polk',
    'Scott',
    'Story',
    'Adams',
    'Montgomery',
    'Page',
    'Ringgold',
    'Taylor',
    'Union',
    'Cherokee',
    'Crawford',
    'Ida',
    'Monona',
    'Plymouth',
    'Woodbury',
  ].sort(),
  Kansas: [
    'Allen',
    'Anderson',
    'Franklin',
    'Osage',
    'Bourbon',
    'Linn',
    'Miami',
    'Atchison',
    'Brown',
    'Doniphan',
    'Jackson',
    'Jefferson',
    'Marshall',
    'Nemaha',
    'Butler',
    'Harvey',
    'Barton',
    'Ellis',
    'Ellsworth',
    'McPherson',
    'Rice',
    'Russell',
    'Chase',
    'Coffey',
    'Lyon',
    'Marion',
    'Cherokee',
    'Crawford',
    'Clay',
    'Cloud',
    'Jewell',
    'Lincoln',
    'Mitchell',
    'Osborne',
    'Ottawa',
    'Republic',
    'Smith',
    'Washington',
    'Dickinson',
    'Geary',
    'Morris',
    'Douglas',
    'Chautauqua',
    'Cowley',
    'Elk',
    'Greenwood',
    'Wilson',
    'Woodson',
    'Johnson',
    'Labette',
    'Montgomery',
    'Neosho',
    'Leavenworth',
    'Cheyenne',
    'Decatur',
    'Gove',
    'Graham',
    'Logan',
    'Norton',
    'Phillips',
    'Rawlins',
    'Rooks',
    'Sheridan',
    'Sherman',
    'Thomas',
    'Trego',
    'Wallace',
    'Clark',
    'Comanche',
    'Edwards',
    'Ford',
    'Hodgman',
    'Kiowa',
    'Ness',
    'Pawnee',
    'Rush',
    'Pottawatomie',
    'Riley',
    'Wabaunsee',
    'Reno',
    'Saline',
    'Finney',
    'Greeley',
    'Hamilton',
    'Kearny',
    'Lane',
    'Scott',
    'Wichita',
    'Sedgwick',
    'Shawnee',
    'Barber',
    'Harper',
    'Kingman',
    'Pratt',
    'Stafford',
    'Sumner',
    'Grant',
    'Gray',
    'Haskell',
    'Meade',
    'Morton',
    'Seward',
    'Stanton',
    'Stevens',
    'Wyandotte',
  ].sort(),
  Kentucky: [
    'Adair',
    'Casey',
    'Green',
    'Russell',
    'Taylor',
    'Anderson',
    'Franklin',
    'Allen',
    'Barren',
    'Hart',
    'Metcalfe',
    'Monroe',
    'Bath',
    'Clark',
    'Montgomery',
    'Rowan',
    'Bell',
    'Harlan',
    'Boone',
    'Bourbon',
    'Fleming',
    'Lewis',
    'Nicholas',
    'Boyd',
    'Carter',
    'Greenup',
    'Boyle',
    'Lincoln',
    'Mercer',
    'Bracken',
    'Harrison',
    'Mason',
    'Pendleton',
    'Robertson',
    'Breckinridge',
    'Grayson',
    'Hancock',
    'Meade',
    'Bullitt',
    'Spencer',
    'Butler',
    'McLean',
    'Muhlenberg',
    'Ohio',
    'Calloway',
    'Marshall',
    'Campbell',
    'Christian',
    'Clay',
    'Jackson',
    'Leslie',
    'Owsley',
    'Clinton',
    'Cumberland',
    'McCreary',
    'Wayne',
    'Daviess',
    'Edmonson',
    'Warren',
    'Elliott',
    'Johnson',
    'Lawrence',
    'Magoffin',
    'Estill',
    'Madison',
    'Rockcastle',
    'Fayette',
    'Floyd',
    'Martin',
    'Garrard',
    'Jessamine',
    'Hardin',
    'Larue',
    'Henderson',
    'Union',
    'Henry',
    'Shelby',
    'Hopkins',
    'Webster',
    'Jefferson',
    'Kenton',
    'Knott',
    'Letcher',
    'Perry',
    'Knox',
    'Whitley',
    'Laurel',
    'Logan',
    'Simpson',
    'Todd',
    'Caldwell',
    'Crittenden',
    'Livingston',
    'Lyon',
    'Trigg',
    'McCracken',
    'Marion',
    'Nelson',
    'Washington',
    'Oldham',
    'Carroll',
    'Gallatin',
    'Grant',
    'Owen',
    'Trimble',
    'Pike',
    'Pulaski',
    'Scott',
    'Woodford',
    'Ballard',
    'Carlisle',
    'Fulton',
    'Graves',
    'Hickman',
    'Breathitt',
    'Lee',
    'Menifee',
    'Morgan',
    'Powell',
    'Wolfe',
  ].sort(),
  Louisiana: [
    'Acadia',
    'Jefferson Davis',
    'Allen',
    'Evangeline',
    'Ascension',
    'Assumption',
    'St. James',
    'St. John the Baptist',
    'Avoyelles',
    'East Feliciana',
    'Pointe Coupee',
    'West Feliciana',
    'Beauregard',
    'Vernon',
    'Bienville',
    'Natchitoches',
    'Red River',
    'Bossier',
    'Caddo',
    'Calcasieu',
    'Cameron',
    'Vermilion',
    'Caldwell',
    'Catahoula',
    'Concordia',
    'La Salle',
    'Tensas',
    'Claiborne',
    'Webster',
    'De Soto',
    'Sabine',
    'East Baton Rouge',
    'Grant',
    'Jackson',
    'Winn',
    'Iberia',
    'Iberville',
    'West Baton Rouge',
    'Jefferson',
    'Lafayette',
    'Lafourche',
    'Lincoln',
    'Union',
    'Livingston',
    'East Carroll',
    'Franklin',
    'Madison',
    'Morehouse',
    'Richland',
    'West Carroll',
    'Orleans',
    'Ouachita',
    'Plaquemines',
    'St. Bernard',
    'Rapides',
    'St. Charles',
    'St. Helena',
    'Tangipahoa',
    'Washington',
    'St. Landry',
    'St. Martin',
    'St. Mary',
    'St. Tammany',
    'Terrebonne',
  ].sort(),
  Maine: [
    'Androscoggin',
    'Aroostook',
    'Cumberland',
    'Franklin',
    'Oxford',
    'Hancock',
    'Washington',
    'Kennebec',
    'Knox',
    'Waldo',
    'Lincoln',
    'Sagadahoc',
    'Penobscot',
    'Piscataquis',
    'Somerset',
    'York',
  ].sort(),
  Maryland: [
    'Allegany',
    'Garrett',
    'Anne Arundel',
    'Baltimore (city)',
    'Baltimore (county)',
    'Calvert',
    'Caroline',
    'Dorchester',
    'Talbot',
    'Carroll',
    'Cecil',
    'Charles',
    'Frederick',
    'Harford',
    'Howard',
    'Kent',
    'Queen Anne`s',
    'Montgomery',
    'Prince George`s',
    'St. Mary`s',
    'Somerset',
    'Worcester',
    'Washington',
    'Wicomico',
  ].sort(),
  Massachusetts: [
    'Barnstable',
    'Dukes',
    'Nantucket',
    'Berkshire',
    'Bristol',
    'Essex',
    'Franklin',
    'Hampden',
    'Hampshire',
    'Middlesex',
    'Norfolk',
    'Plymouth',
    'Suffolk',
    'Worcester',
  ].sort(),
  Michigan: [
    'Alcona',
    'Alpena',
    'Presque Isle',
    'Alger',
    'Delta',
    'Schoolcraft',
    'Allegan',
    'Antrim',
    'Charlevoix',
    'Kalkaska',
    'Otsego',
    'Arenac',
    'Iosco',
    'Ogemaw',
    'Barry',
    'Bay',
    'Benzie',
    'Manistee',
    'Mason',
    'Berrien',
    'Branch',
    'Hillsdale',
    'Calhoun',
    'Cass',
    'Cheboygan',
    'Emmet',
    'Chippewa',
    'Luce',
    'Mackinac',
    'Clare',
    'Gladwin',
    'Clinton',
    'Crawford',
    'Montmorency',
    'Oscoda',
    'Roscommon',
    'Dickinson',
    'Iron',
    'Menominee',
    'Eaton',
    'Genesee',
    'Grand Traverse',
    'Leelanau',
    'Gratiot',
    'Isabella',
    'Huron',
    'Sanilac',
    'Ingham',
    'Ionia',
    'Jackson',
    'Kalamazoo',
    'Kent',
    'Lake',
    'Missaukee',
    'Wexford',
    'Lapeer',
    'Lenawee',
    'Livingston',
    'Macomb',
    'Marquette',
    'Mecosta',
    'Osceola',
    'Midland',
    'Monroe',
    'Montcalm',
    'Muskegon',
    'Newaygo',
    'Oceana',
    'Baraga',
    'Gogebic',
    'Houghton',
    'Keweenaw',
    'Ontonagon',
    'Oakland',
    'Ottawa',
    'Saginaw',
    'St. Clair',
    'St. Joseph',
    'Shiawassee',
    'Tuscola',
    'Van Buren',
    'Washtenaw',
    'Wayne',
  ].sort(),
  Minnesota: [
    'Aitkin',
    'Itasca',
    'Anoka',
    'Becker',
    'Hubbard',
    'Mahnomen',
    'Norman',
    'Beltrami',
    'Clearwater',
    'Benton',
    'Stearns',
    'Blue Earth',
    'Faribault',
    'Martin',
    'Watonwan',
    'Brown',
    'Le Sueur',
    'Nicollet',
    'Carver',
    'Cass',
    'Crow Wing',
    'Chisago',
    'Isanti',
    'Clay',
    'Dakota',
    'Dodge',
    'Steele',
    'Waseca',
    'Douglas',
    'Morrison',
    'Todd',
    'Fillmore',
    'Houston',
    'Winona',
    'Freeborn',
    'Mower',
    'Goodhue',
    'Wabasha',
    'Hennepin',
    'Kanabec',
    'Mille Lacs',
    'Pine',
    'Kandiyohi',
    'Renville',
    'McLeod',
    'Meeker',
    'Sibley',
    'Kittson',
    'Lake of the Woods',
    'Marshall',
    'Pennington',
    'Polk',
    'Red Lake',
    'Roseau',
    'Olmsted',
    'Otter Tail',
    'Wadena',
    'Wilkin',
    'Ramsey',
    'Rice',
    'Carlton',
    'Cook',
    'Koochiching',
    'Lake',
    'St. Louis',
    'Scott',
    'Sherburne',
    'Cottonwood',
    'Jackson',
    'Murray',
    'Nobles',
    'Pipestone',
    'Rock',
    'Big Stone',
    'Chippewa',
    'Grant',
    'Pope',
    'Stevens',
    'Swift',
    'Traverse',
    'Washington',
    'Wright',
    'Lac Qui Parle',
    'Lincoln',
    'Lyon',
    'Redwood',
    'Yellow Medicine',
  ].sort(),
  Mississippi: [
    'Adams',
    'Amite',
    'Wilkinson',
    'Alcorn',
    'Prentiss',
    'Tishomingo',
    'Attala',
    'Choctaw',
    'Leake',
    'Webster',
    'Benton',
    'Marshall',
    'Tippah',
    'Bolivar',
    'Sunflower',
    'Calhoun',
    'Chickasaw',
    'Grenada',
    'Carroll',
    'Leflore',
    'Montgomery',
    'Claiborne',
    'Jefferson',
    'Warren',
    'Clarke',
    'Jasper',
    'Wayne',
    'Clay',
    'Oktibbeha',
    'Coahoma',
    'Quitman',
    'Tallahatchie',
    'Tunica',
    'Copiah',
    'Franklin',
    'Lincoln',
    'Covington',
    'Simpson',
    'Smith',
    'De Soto',
    'Forrest',
    'George',
    'Greene',
    'Perry',
    'Stone',
    'Hancock',
    'Harrison',
    'Hinds',
    'Itawamba',
    'Monroe',
    'Jackson',
    'Jefferson Davis',
    'Lawrence',
    'Marion',
    'Jones',
    'Kemper',
    'Neshoba',
    'Noxubee',
    'Winston',
    'Lafayette',
    'Yalobusha',
    'Lamar',
    'Lauderdale',
    'Newton',
    'Lee',
    'Lowndes',
    'Madison',
    'Panola',
    'Tate',
    'Pearl River',
    'Pike',
    'Walthall',
    'Pontotoc',
    'Union',
    'Rankin',
    'Scott',
    'Washington',
    'Holmes',
    'Humphreys',
    'Issaquena',
    'Sharkey',
    'Yazoo',
  ].sort(),
  Missouri: [
    'Andrew',
    'Atchison',
    'Holt',
    'Nodaway',
    'Audrain',
    'Callaway',
    'Barry',
    'Lawrence',
    'McDonald',
    'Benton',
    'Henry',
    'St. Clair',
    'Bollinger',
    'Madison',
    'Stoddard',
    'Wayne',
    'Boone',
    'Buchanan',
    'Butler',
    'Carter',
    'Ripley',
    'Camden',
    'Miller',
    'Moniteau',
    'Morgan',
    'Cape Girardeau',
    'Perry',
    'Carroll',
    'Lafayette',
    'Ray',
    'Cass',
    'Christian',
    'Clay',
    'Cole',
    'Crawford',
    'Iron',
    'Reynolds',
    'Washington',
    'Dallas',
    'Hickory',
    'Polk',
    'Caldwell',
    'Clinton',
    'Daviess',
    'DeKalb',
    'Gentry',
    'Harrison',
    'Worth',
    'Dent',
    'Phelps',
    'Douglas',
    'Ozark',
    'Texas',
    'Wright',
    'Dunklin',
    'Pemiscot',
    'Franklin',
    'Gasconade',
    'Montgomery',
    'Warren',
    'Greene',
    'Grundy',
    'Linn',
    'Livingston',
    'Mercer',
    'Putnam',
    'Sullivan',
    'Howell',
    'Oregon',
    'Shannon',
    'Jackson',
    'Jasper',
    'Jefferson',
    'Johnson',
    'Laclede',
    'Webster',
    'Lincoln',
    'Pike',
    'Maries',
    'Osage',
    'Pulaski',
    'Marion',
    'Monroe',
    'Ralls',
    'Shelby',
    'Mississippi',
    'New Madrid',
    'Scott',
    'Newton',
    'Pettis',
    'Saline',
    'Platte',
    'Chariton',
    'Cooper',
    'Howard',
    'Macon',
    'Randolph',
    'St. Charles',
    'Ste. Genevieve',
    'St. Francois',
    'St. Louis (city)',
    'St. Louis (county)',
    'Adair',
    'Clark',
    'Knox',
    'Lewis',
    'Schuyler',
    'Scotland',
    'Stone',
    'Taney',
    'Barton',
    'Bates',
    'Cedar',
    'Dade',
    'Vernon',
  ].sort(),
  Montana: [
    'Beaverhead',
    'Gallatin',
    'Madison',
    'Cascade',
    'Deer Lodge',
    'Granite',
    'Powell',
    'Ravalli',
    'Silver Bow',
    'Big Horn',
    'Carter',
    'Custer',
    'Daniels',
    'Dawson',
    'Fallon',
    'Garfield',
    'McCone',
    'Phillips',
    'Powder River',
    'Prairie',
    'Richland',
    'Roosevelt',
    'Rosebud',
    'Sheridan',
    'Treasure',
    'Valley',
    'Wibaux',
    'Flathead',
    'Jefferson',
    'Lewis and Clark',
    'Lake',
    'Lincoln',
    'Mineral',
    'Sanders',
    'Missoula',
    'Blaine',
    'Chouteau',
    'Fergus',
    'Glacier',
    'Hill',
    'Judith Basin',
    'Liberty',
    'Petroleum',
    'Pondera',
    'Teton',
    'Toole',
    'Broadwater',
    'Carbon',
    'Golden Valley',
    'Meagher',
    'Musselshell',
    'Stillwater',
    'Sweet Grass',
    'Wheatland',
    'Yellowstone',
  ].sort(),
  Nebraska: [
    'Banner',
    'Cheyenne',
    'Kimball',
    'Morrill',
    'Scotts Bluff',
    'Buffalo',
    'Kearney',
    'Sherman',
    'Burt',
    'Dakota',
    'Thurston',
    'Washington',
    'Cedar',
    'Colfax',
    'Cuming',
    'Dixon',
    'Stanton',
    'Wayne',
    'Dodge',
    'Saunders',
    'Douglas',
    'Chase',
    'Dawson',
    'Dundy',
    'Frontier',
    'Gosper',
    'Hayes',
    'Hitchcock',
    'Red Willow',
    'Hall',
    'Howard',
    'Merrick',
    'Nance',
    'Platte',
    'Lancaster',
    'Deuel',
    'Keith',
    'Lincoln',
    'Logan',
    'McPherson',
    'Perkins',
    'Arthur',
    'Blaine',
    'Box Butte',
    'Brown',
    'Cherry',
    'Custer',
    'Dawes',
    'Garden',
    'Grant',
    'Hooker',
    'Keya Paha',
    'Loup',
    'Rock',
    'Sheridan',
    'Sioux',
    'Thomas',
    'Fillmore',
    'Gage',
    'Jefferson',
    'Nuckolls',
    'Saline',
    'Thayer',
    'Sarpy',
    'Adams',
    'Clay',
    'Franklin',
    'Furnas',
    'Harlan',
    'Phelps',
    'Webster',
    'Cass',
    'Johnson',
    'Nemaha',
    'Otoe',
    'Pawnee',
    'Richardson',
    'Antelope',
    'Boone',
    'Boyd',
    'Garfield',
    'Greeley',
    'Holt',
    'Knox',
    'Madison',
    'Pierce',
    'Valley',
    'Wheeler',
    'Butler',
    'Hamilton',
    'Polk',
    'Seward',
    'York',
  ].sort(),
  Nevada: [
    'Douglas',
    'Carson City (city)',
    'Clark',
    'Nye',
    'Churchill',
    'Esmeralda',
    'Lyon',
    'Mineral',
    'Storey',
    'Elko',
    'Eureka',
    'Humboldt',
    'Lander',
    'Lincoln',
    'Pershing',
    'White Pine',
    'Washoe',
  ].sort(),
  ['New Hampshire']: [
    'Belknap',
    'Carroll',
    'Cheshire',
    'Coos',
    'Grafton',
    'Hillsborough',
    'Merrimack',
    'Sullivan',
    'Rockingham',
    'Strafford',
  ].sort(),
  ['New Jersey']: [
    'Atlantic',
    'Bergen',
    'Burlington',
    'Camden',
    'Cape May',
    'Cumberland',
    'Essex',
    'Gloucester',
    'Hudson',
    'Hunterdon',
    'Mercer',
    'Middlesex',
    'Monmouth',
    'Morris',
    'Ocean',
    'Passaic',
    'Salem',
    'Somerset',
    'Sussex',
    'Union',
    'Warren',
  ].sort(),
  ['New Mexico']: [
    'Bernalillo',
    'Catron',
    'Cibola',
    'Sierra',
    'Socorro',
    'Chaves',
    'Curry',
    'Roosevelt',
    'DoÔøΩa Ana',
    'Eddy',
    'Grant',
    'Hidalgo',
    'Luna',
    'De Baca',
    'Guadalupe',
    'Lincoln',
    'Quay',
    'Torrance',
    'Lea',
    'Los Alamos',
    'Santa Fe',
    'McKinley',
    'Colfax',
    'Harding',
    'Mora',
    'San Miguel',
    'Union',
    'Otero',
    'Rio Arriba',
    'Taos',
    'Sandoval',
    'San Juan',
    'Valencia',
  ].sort(),
  ['New York']: [
    'Albany',
    'Greene',
    'Allegany',
    'Steuben',
    'Bronx',
    'Broome',
    'Cattaraugus',
    'Wyoming',
    'Cayuga',
    'Chautauqua',
    'Chemung',
    'Chenango',
    'Cortland',
    'Clinton',
    'Columbia',
    'Delaware',
    'Schoharie',
    'Dutchess',
    'Erie',
    'Essex',
    'Franklin',
    'Fulton',
    'Hamilton',
    'Genesee',
    'Orleans',
    'Herkimer',
    'Jefferson',
    'Lewis',
    'Kings',
    'Livingston',
    'Madison',
    'Monroe',
    'Montgomery',
    'Nassau',
    'New York (county)',
    'Niagara',
    'Oneida',
    'Onondaga',
    'Ontario',
    'Orange',
    'Oswego',
    'Otsego',
    'Putnam',
    'Queens',
    'Rensselaer',
    'Richmond',
    'Rockland',
    'St. Lawrence',
    'Saratoga',
    'Schenectady',
    'Schuyler',
    'Seneca',
    'Yates',
    'Suffolk',
    'Sullivan',
    'Tioga',
    'Tompkins',
    'Ulster',
    'Warren',
    'Washington',
    'Wayne',
    'Westchester',
  ].sort(),
  ['North Carolina']: [
    'Alamance',
    'Alexander',
    'Catawba',
    'Alleghany',
    'Ashe',
    'Avery',
    'Watauga',
    'Anson',
    'Richmond',
    'Beaufort',
    'Martin',
    'Pamlico',
    'Bladen',
    'Columbus',
    'Brunswick',
    'Buncombe',
    'Madison',
    'Burke',
    'Cabarrus',
    'Caldwell',
    'Camden',
    'Currituck',
    'Pasquotank',
    'Carteret',
    'Caswell',
    'Person',
    'Chatham',
    'Cherokee',
    'Clay',
    'Graham',
    'Swain',
    'Cleveland',
    'Craven',
    'Cumberland',
    'Dare',
    'Hyde',
    'Tyrrell',
    'Washington',
    'Davidson',
    'Davie',
    'Yadkin',
    'Duplin',
    'Durham',
    'Edgecombe',
    'Forsyth',
    'Stokes',
    'Franklin',
    'Warren',
    'Gaston',
    'Bertie',
    'Chowan',
    'Gates',
    'Hertford',
    'Perquimans',
    'Granville',
    'Vance',
    'Greene',
    'Jones',
    'Lenoir',
    'Guilford',
    'Halifax',
    'Northampton',
    'Harnett',
    'Haywood',
    'Henderson',
    'Hoke',
    'Scotland',
    'Iredell',
    'Jackson',
    'Macon',
    'Transylvania',
    'Johnston',
    'Lee',
    'Lincoln',
    'McDowell',
    'Mitchell',
    'Yancey',
    'Mecklenburg',
    'Montgomery',
    'Moore',
    'Nash',
    'New Hanover',
    'Onslow',
    'Orange',
    'Pender',
    'Pitt',
    'Polk',
    'Rutherford',
    'Randolph',
    'Robeson',
    'Rockingham',
    'Rowan',
    'Sampson',
    'Stanly',
    'Surry',
    'Union',
    'Wake',
    'Wayne',
    'Wilkes',
    'Wilson',
  ].sort(),
  ['North Dakota']: [
    'Benson',
    'Eddy',
    'Foster',
    'Griggs',
    'Pierce',
    'Ramsey',
    'Rolette',
    'Towner',
    'Wells',
    'Cass',
    'Barnes',
    'Dickey',
    'LaMoure',
    'Ransom',
    'Richland',
    'Sargent',
    'Stutsman',
    'Bottineau',
    'McHenry',
    'McLean',
    'Renville',
    'Sheridan',
    'Ward',
    'Cavalier',
    'Grand Forks',
    'Nelson',
    'Pembina',
    'Steele',
    'Traill',
    'Walsh',
    'Billings',
    'Burke',
    'Divide',
    'Dunn',
    'Golden Valley',
    'McKenzie',
    'Mountrail',
    'Stark',
    'Williams',
    'Burleigh',
    'Emmons',
    'Kidder',
    'Logan',
    'McIntosh',
    'Adams',
    'Bowman',
    'Grant',
    'Hettinger',
    'Mercer',
    'Morton',
    'Oliver',
    'Sioux',
    'Slope',
  ].sort(),
  Ohio: [
    'Adams',
    'Brown',
    'Allen',
    'Ashland',
    'Ashtabula',
    'Athens',
    'Hocking',
    'Auglaize',
    'Mercer',
    'Belmont',
    'Butler',
    'Carroll',
    'Harrison',
    'Tuscarawas',
    'Champaign',
    'Logan',
    'Madison',
    'Shelby',
    'Clark',
    'Clermont',
    'Clinton',
    'Fayette',
    'Highland',
    'Columbiana',
    'Coshocton',
    'Holmes',
    'Crawford',
    'Richland',
    'Cuyahoga',
    'Darke',
    'Preble',
    'Defiance',
    'Williams',
    'Delaware',
    'Erie',
    'Fairfield',
    'Franklin',
    'Fulton',
    'Henry',
    'Gallia',
    'Meigs',
    'Geauga',
    'Greene',
    'Guernsey',
    'Monroe',
    'Noble',
    'Hamilton',
    'Hancock',
    'Hardin',
    'Wyandot',
    'Huron',
    'Jackson',
    'Pike',
    'Vinton',
    'Jefferson',
    'Knox',
    'Morrow',
    'Lake',
    'Lawrence',
    'Licking',
    'Lorain',
    'Lucas',
    'Ottawa',
    'Mahoning',
    'Marion',
    'Medina',
    'Miami',
    'Montgomery',
    'Morgan',
    'Perry',
    'Muskingum',
    'Paulding',
    'Putnam',
    'Van Wert',
    'Pickaway',
    'Portage',
    'Ross',
    'Sandusky',
    'Scioto',
    'Seneca',
    'Stark',
    'Summit',
    'Trumbull',
    'Union',
    'Warren',
    'Washington',
    'Wayne',
    'Wood',
  ].sort(),
  Oklahoma: [
    'Adair',
    'Cherokee',
    'Sequoyah',
    'Atoka',
    'Bryan',
    'Coal',
    'Beckham',
    'Custer',
    'Roger Mills',
    'Washita',
    'Caddo',
    'Grady',
    'Canadian',
    'Carter',
    'Johnston',
    'Love',
    'Marshall',
    'Choctaw',
    'McCurtain',
    'Pushmataha',
    'Cleveland',
    'Comanche',
    'Cotton',
    'Jefferson',
    'Stephens',
    'Craig',
    'Mayes',
    'Creek',
    'Delaware',
    'Ottawa',
    'Garfield',
    'Garvin',
    'McClain',
    'Murray',
    'Grant',
    'Kay',
    'Haskell',
    'Latimer',
    'Pittsburg',
    'Hughes',
    'Okfuskee',
    'Pontotoc',
    'Seminole',
    'Le Flore',
    'Lincoln',
    'Logan',
    'McIntosh',
    'Okmulgee',
    'Alfalfa',
    'Blaine',
    'Dewey',
    'Kingfisher',
    'Major',
    'Woods',
    'Muskogee',
    'Noble',
    'Osage',
    'Pawnee',
    'Nowata',
    'Washington',
    'Oklahoma (county)',
    'Beaver',
    'Cimarron',
    'Ellis',
    'Harper',
    'Texas',
    'Woodward',
    'Payne',
    'Pottawatomie',
    'Rogers',
    'Greer',
    'Harmon',
    'Jackson',
    'Kiowa',
    'Tillman',
    'Tulsa',
    'Wagoner',
  ].sort(),
  Oregon: [
    'Baker',
    'Harney',
    'Lake',
    'Malheur',
    'Benton',
    'Clackamas',
    'Clatsop',
    'Lincoln',
    'Tillamook',
    'Columbia',
    'Washington',
    'Coos',
    'Curry',
    'Deschutes',
    'Douglas',
    'Hood River',
    'Jefferson',
    'Sherman',
    'Wasco',
    'Jackson',
    'Josephine',
    'Klamath',
    'Lane',
    'Linn',
    'Marion',
    'Multnomah',
    'Polk',
    'Crook',
    'Gilliam',
    'Grant',
    'Morrow',
    'Umatilla',
    'Union',
    'Wallowa',
    'Wheeler',
    'Yamhill',
  ].sort(),
  Pennsylvania: [
    'Adams',
    'Allegheny',
    'Armstrong',
    'Beaver',
    'Bedford',
    'Fulton',
    'Berks',
    'Blair',
    'Bradford',
    'Sullivan',
    'Bucks',
    'Butler',
    'Cambria',
    'Carbon',
    'Centre',
    'Chester',
    'Clarion',
    'Jefferson',
    'Clearfield',
    'Clinton',
    'Potter',
    'Tioga',
    'Columbia',
    'Crawford',
    'Cumberland',
    'Perry',
    'Dauphin',
    'Delaware',
    'Erie',
    'Fayette',
    'Greene',
    'Franklin',
    'Huntingdon',
    'Juniata',
    'Mifflin',
    'Indiana',
    'Lackawanna',
    'Wyoming',
    'Lancaster',
    'Lawrence',
    'Lebanon',
    'Lehigh',
    'Luzerne',
    'Lycoming',
    'Cameron',
    'Elk',
    'Forest',
    'McKean',
    'Warren',
    'Mercer',
    'Monroe',
    'Montgomery',
    'Montour',
    'Northumberland',
    'Northampton',
    'Philadelphia',
    'Pike',
    'Schuylkill',
    'Snyder',
    'Union',
    'Somerset',
    'Susquehanna',
    'Wayne',
    'Venango',
    'Washington',
    'Westmoreland',
    'York',
  ].sort(),
  ['Rhode Island']: ['Bristol', 'Providence', 'Kent', 'Newport', 'Washington'].sort(),
  ['South Carolina']: [
    'Abbeville',
    'Edgefield',
    'Greenwood',
    'McCormick',
    'Aiken',
    'Anderson',
    'Beaufort',
    'Berkeley',
    'Calhoun',
    'Richland',
    'Charleston',
    'Cherokee',
    'Chester',
    'Fairfield',
    'Chesterfield',
    'Marlboro',
    'Clarendon',
    'Williamsburg',
    'Darlington',
    'Dillon',
    'Marion',
    'Dorchester',
    'Florence',
    'Georgetown',
    'Greenville',
    'Allendale',
    'Bamberg',
    'Barnwell',
    'Colleton',
    'Hampton',
    'Jasper',
    'Horry',
    'Kershaw',
    'Lee',
    'Lancaster',
    'Laurens',
    'Lexington',
    'Newberry',
    'Saluda',
    'Oconee',
    'Orangeburg',
    'Pickens',
    'Spartanburg',
    'Union',
    'Sumter',
    'York',
  ].sort(),
  ['South Dakota']: [
    'Beadle',
    'Clark',
    'Codington',
    'Deuel',
    'Hamlin',
    'Kingsbury',
    'Spink',
    'Clay',
    'Turner',
    'Union',
    'Yankton',
    'Aurora',
    'Bon Homme',
    'Brule',
    'Charles Mix',
    'Davison',
    'Douglas',
    'Hutchinson',
    'Lincoln',
    'Minnehaha',
    'Brookings',
    'Hanson',
    'Jerauld',
    'Lake',
    'McCook',
    'Miner',
    'Moody',
    'Sanborn',
    'Buffalo',
    'Campbell',
    'Edmunds',
    'Faulk',
    'Hand',
    'Hughes',
    'Hyde',
    'Lyman',
    'McPherson',
    'Potter',
    'Stanley',
    'Sully',
    'Walworth',
    'Brown',
    'Day',
    'Grant',
    'Marshall',
    'Roberts',
    'Butte',
    'Corson',
    'Dewey',
    'Harding',
    'Lawrence',
    'Meade',
    'Perkins',
    'Ziebach',
    'Pennington',
    'Bennett',
    'Custer',
    'Fall River',
    'Gregory',
    'Haakon',
    'Jackson',
    'Jones',
    'Mellette',
    'Southwest Central South Dakota',
    'Todd',
    'Tripp',
  ].sort(),
  Tennessee: [
    'Anderson',
    'Bedford',
    'Lincoln',
    'Moore',
    'Benton',
    'Carroll',
    'Henry',
    'Bledsoe',
    'Rhea',
    'Van Buren',
    'White',
    'Blount',
    'Loudon',
    'Bradley',
    'Polk',
    'Campbell',
    'Claiborne',
    'Hancock',
    'Scott',
    'Cannon',
    'DeKalb',
    'Warren',
    'Carter',
    'Johnson',
    'Unicoi',
    'Cheatham',
    'Dickson',
    'Chester',
    'Madison',
    'Cocke',
    'Jefferson',
    'Coffee',
    'Franklin',
    'Crockett',
    'Gibson',
    'Haywood',
    'Cumberland',
    'Fentress',
    'Davidson',
    'Decatur',
    'Henderson',
    'Lewis',
    'Perry',
    'Dyer',
    'Lake',
    'Lauderdale',
    'Fayette',
    'Hardeman',
    'Giles',
    'Marshall',
    'Grainger',
    'Hamblen',
    'Greene',
    'Grundy',
    'Marion',
    'Sequatchie',
    'Hamilton',
    'Hardin',
    'McNairy',
    'Hawkins',
    'Hickman',
    'Houston',
    'Humphreys',
    'Stewart',
    'Jackson',
    'Putnam',
    'Smith',
    'Knox',
    'Union',
    'Lawrence',
    'Wayne',
    'McMinn',
    'Meigs',
    'Monroe',
    'Maury',
    'Montgomery',
    'Morgan',
    'Roane',
    'Clay',
    'Macon',
    'Overton',
    'Pickett',
    'Trousdale',
    'Obion',
    'Weakley',
    'Robertson',
    'Rutherford',
    'Sevier',
    'Shelby',
    'Sullivan',
    'Sumner',
    'Tipton',
    'Washington',
    'Williamson',
    'Wilson',
  ].sort(),
  Texas: [
    'Anderson',
    'Houston',
    'Angelina',
    'Aransas',
    'Calhoun',
    'Refugio',
    'Archer',
    'Wichita',
    'Atascosa',
    'Live Oak',
    'McMullen',
    'Austin',
    'Waller',
    'Washington',
    'Bandera',
    'Kendall',
    'Kerr',
    'Bastrop',
    'Caldwell',
    'Bee',
    'Goliad',
    'Karnes',
    'Bell',
    'Bexar',
    'Wilson',
    'Bosque',
    'Hamilton',
    'Hill',
    'Bowie',
    'Brazoria',
    'Brazos',
    'Burleson',
    'Grimes',
    'Robertson',
    'Brown',
    'Coleman',
    'Mills',
    'Burnet',
    'Lampasas',
    'Llano',
    'Callahan',
    'Eastland',
    'Jones',
    'Shackelford',
    'Stephens',
    'Cameron',
    'Cass',
    'Marion',
    'Morris',
    'Chambers',
    'Liberty',
    'Cherokee',
    'Clay',
    'Cooke',
    'Montague',
    'Collin',
    'Comal',
    'Comanche',
    'Erath',
    'Somervell',
    'Coryell',
    'Crockett',
    'Kinney',
    'Terrell',
    'Val Verde',
    'Crosby',
    'Floyd',
    'Hale',
    'Swisher',
    'Dallas',
    'Denton',
    'Dimmit',
    'La Salle',
    'Maverick',
    'Brooks',
    'Duval',
    'Jim Hogg',
    'Jim Wells',
    'Zapata',
    'Armstrong',
    'Baylor',
    'Briscoe',
    'Childress',
    'Cottle',
    'Dickens',
    'Donley',
    'Foard',
    'Hall',
    'Hardeman',
    'Haskell',
    'King',
    'Knox',
    'Motley',
    'Stonewall',
    'Throckmorton',
    'Wilbarger',
    'Ector',
    'Ellis',
    'El Paso',
    'Falls',
    'Lee',
    'Milam',
    'Fannin',
    'Lamar',
    'Red River',
    'Fort Bend',
    'Freestone',
    'Leon',
    'Limestone',
    'Navarro',
    'Frio',
    'Medina',
    'Uvalde',
    'Zavala',
    'Andrews',
    'Dawson',
    'Gaines',
    'Lynn',
    'Martin',
    'Terry',
    'Yoakum',
    'Galveston',
    'Grayson',
    'Gregg',
    'Guadalupe',
    'Hardin',
    'Harris',
    'Harrison',
    'Upshur',
    'Hays',
    'Henderson',
    'Hidalgo',
    'Hood',
    'Camp',
    'Delta',
    'Franklin',
    'Hopkins',
    'Titus',
    'Wood',
    'Hunt',
    'Jack',
    'Palo Pinto',
    'Young',
    'Jackson',
    'Matagorda',
    'Wharton',
    'Jasper',
    'Newton',
    'Jefferson',
    'Johnson',
    'Kaufman',
    'Kenedy',
    'Kleberg',
    'Willacy',
    'Colorado',
    'DeWitt',
    'Fayette',
    'Gonzales',
    'Lavaca',
    'Lubbock',
    'McLennan',
    'Madison',
    'Trinity',
    'Walker',
    'Blanco',
    'Coke',
    'Concho',
    'Edwards',
    'Gillespie',
    'Glasscock',
    'Irion',
    'Kimble',
    'McCulloch',
    'Mason',
    'Menard',
    'Reagan',
    'Real',
    'Runnels',
    'San Saba',
    'Schleicher',
    'Sterling',
    'Sutton',
    'Midland',
    'Montgomery',
    'Nacogdoches',
    'Collingsworth',
    'Gray',
    'Hansford',
    'Hemphill',
    'Lipscomb',
    'Ochiltree',
    'Roberts',
    'Wheeler',
    'Carson',
    'Dallam',
    'Hartley',
    'Hutchinson',
    'Moore',
    'Oldham',
    'Sherman',
    'Nueces',
    'Orange',
    'Panola',
    'Sabine',
    'San Augustine',
    'Shelby',
    'Parker',
    'Polk',
    'San Jacinto',
    'Tyler',
    'Potter',
    'Rains',
    'Van Zandt',
    'Randall',
    'Rockwall',
    'Rusk',
    'San Patricio',
    'Borden',
    'Fisher',
    'Garza',
    'Howard',
    'Kent',
    'Mitchell',
    'Nolan',
    'Scurry',
    'Smith',
    'Starr',
    'Tarrant',
    'Taylor',
    'Tom Green',
    'Travis',
    'Victoria',
    'Webb',
    'Bailey',
    'Castro',
    'Cochran',
    'Deaf Smith',
    'Hockley',
    'Lamb',
    'Parmer',
    'Brewster',
    'Crane',
    'Culberson',
    'Hudspeth',
    'Jeff Davis',
    'Loving',
    'Pecos',
    'Presidio',
    'Reeves',
    'Upton',
    'Ward',
    'Winkler',
    'Williamson',
    'Wise',
  ].sort(),
  Utah: [
    'Beaver',
    'Iron',
    'Millard',
    'Box Elder',
    'Cache',
    'Rich',
    'Carbon',
    'Daggett',
    'Duchesne',
    'Uintah',
    'Davis',
    'Juab',
    'Sanpete',
    'Tooele',
    'Morgan',
    'Summit',
    'Wasatch',
    'Salt Lake',
    'Utah (county)',
    'Washington',
    'Emery',
    'Garfield',
    'Grand',
    'Kane',
    'Piute',
    'San Juan',
    'Sevier',
    'Wayne',
    'Weber',
  ].sort(),
  Vermont: [
    'Addison',
    'Chittenden',
    'Bennington',
    'Windham',
    'Caledonia',
    'Essex',
    'Orange',
    'Franklin',
    'Grand Isle',
    'Lamoille',
    'Orleans',
    'Rutland',
    'Washington',
    'Windsor',
  ].sort(),
  Virginia: [
    'Accomack',
    'Northampton',
    'Virginia Beach (city)',
    'Albemarle',
    'Charlottesville (city)',
    'Alexandria (city)',
    'Alleghany',
    'Bath',
    'Botetourt',
    'Highland',
    'Covington (city)',
    'Amelia',
    'Brunswick',
    'Lunenburg',
    'Nottoway',
    'Amherst',
    'Nelson',
    'Lynchburg (city)',
    'Appomattox',
    'Campbell',
    'Arlington',
    'Augusta',
    'Rockbridge',
    'Buena Vista (city)',
    'Lexington (city)',
    'Staunton (city)',
    'Waynesboro (city)',
    'Bedford (county)',
    'Bland',
    'Smyth',
    'Wythe',
    'Washington',
    'Bristol (city)',
    'Buchanan',
    'Dickenson',
    'Russell',
    'Tazewell',
    'Carroll',
    'Grayson',
    'Galax (city)',
    'Charles City',
    'Goochland',
    'Henrico',
    'New Kent',
    'Chesapeake (city)',
    'Chesterfield',
    'Powhatan',
    'Colonial Heights (city)',
    'Clarke',
    'Warren',
    'Craig',
    'Franklin (county)',
    'Roanoke (county)',
    'Salem (city)',
    'Culpeper',
    'Madison',
    'Rappahannock',
    'Pittsylvania',
    'Danville (city)',
    'Dinwiddie',
    'Petersburg (city)',
    'Fairfax (county)',
    'Fairfax (city)',
    'Falls Church (city)',
    'Fauquier',
    'Floyd',
    'Giles',
    'Montgomery',
    'Frederick',
    'Winchester (city)',
    'Spotsylvania',
    'Fredericksburg (city)',
    'Greene',
    'Louisa',
    'Orange',
    'Halifax',
    'Mecklenburg',
    'Hampton (city)',
    'Poquoson (city)',
    'Hanover',
    'Rockingham',
    'Harrisonburg (city)',
    'Henry',
    'Patrick',
    'Martinsville (city)',
    'Prince George',
    'Hopewell (city)',
    'James City',
    'Williamsburg (city)',
    'Caroline',
    'Essex',
    'Gloucester',
    'King and Queen',
    'King William',
    'Mathews',
    'Middlesex',
    'Lee',
    'Scott',
    'Wise',
    'Norton (city)',
    'Loudoun',
    'Manassas (city)',
    'Manassas Park (city)',
    'Newport News (city)',
    'Norfolk (city)',
    'Page',
    'Shenandoah',
    'Portsmouth (city)',
    'Buckingham',
    'Charlotte',
    'Cumberland',
    'Fluvanna',
    'Prince Edward',
    'Prince William',
    'Pulaski',
    'Radford (city)',
    'Richmond (city)',
    'Roanoke (city)',
    'Greensville',
    'Isle of Wight',
    'Southampton',
    'Surry',
    'Sussex',
    'Emporia (city)',
    'Franklin (city)',
    'Stafford',
    'Suffolk (city)',
    'King George',
    'Lancaster',
    'Northumberland',
    'Richmond (county)',
    'Westmoreland',
    'York',
  ].sort(),
  Washington: [
    'Adams',
    'Grant',
    'Asotin',
    'Columbia',
    'Garfield',
    'Whitman',
    'Benton',
    'Chelan',
    'Kittitas',
    'Clallam',
    'Jefferson',
    'Clark',
    'Cowlitz',
    'Klickitat',
    'Skamania',
    'Wahkiakum',
    'Douglas',
    'Okanogan',
    'Ferry',
    'Lincoln',
    'Pend Oreille',
    'Stevens',
    'Franklin',
    'Grays Harbor',
    'Pacific',
    'Island',
    'King',
    'Kitsap',
    'Lewis',
    'Mason',
    'Pierce',
    'San Juan',
    'Skagit',
    'Snohomish',
    'Spokane',
    'Thurston',
    'Walla Walla',
    'Whatcom',
    'Yakima',
  ].sort(),
  ['West Virginia']: [
    'Barbour',
    'Pocahontas',
    'Randolph',
    'Tucker',
    'Berkeley',
    'Morgan',
    'Boone',
    'Lincoln',
    'Logan',
    'Braxton',
    'Gilmer',
    'Lewis',
    'Upshur',
    'Brooke',
    'Hancock',
    'Cabell',
    'Clay',
    'Fayette',
    'Nicholas',
    'Webster',
    'Greenbrier',
    'Monroe',
    'Summers',
    'Grant',
    'Hampshire',
    'Hardy',
    'Mineral',
    'Pendleton',
    'Harrison',
    'Taylor',
    'Calhoun',
    'Jackson',
    'Mason',
    'Roane',
    'Wirt',
    'Jefferson',
    'Kanawha',
    'McDowell',
    'Mercer',
    'Marion',
    'Marshall',
    'Ohio',
    'Mingo',
    'Wayne',
    'Monongalia',
    'Preston',
    'Putnam',
    'Raleigh',
    'Wyoming',
    'Doddridge',
    'Pleasants',
    'Ritchie',
    'Tyler',
    'Wetzel',
    'Wood',
  ].sort(),
  Wisconsin: [
    'Adams',
    'Juneau',
    'Monroe',
    'Vernon',
    'Ashland',
    'Bayfield',
    'Douglas',
    'Price',
    'Barron',
    'Sawyer',
    'Washburn',
    'Brown',
    'Buffalo',
    'Jackson',
    'Pepin',
    'Trempealeau',
    'Burnett',
    'Polk',
    'Calumet',
    'Winnebago',
    'Chippewa',
    'Rusk',
    'Clark',
    'Taylor',
    'Columbia',
    'Crawford',
    'Grant',
    'Richland',
    'Dane',
    'Dodge',
    'Door',
    'Kewaunee',
    'Manitowoc',
    'Dunn',
    'Eau Claire',
    'Florence',
    'Forest',
    'Marinette',
    'Oconto',
    'Fond du Lac',
    'Green',
    'Iowa',
    'Lafayette',
    'Green Lake',
    'Marquette',
    'Waushara',
    'Iron',
    'Oneida',
    'Vilas',
    'Jefferson',
    'Kenosha',
    'La Crosse',
    'Langlade',
    'Lincoln',
    'Menominee',
    'Shawano',
    'Marathon',
    'Milwaukee',
    'Outagamie',
    'Ozaukee',
    'Pierce',
    'St. Croix',
    'Portage',
    'Racine',
    'Rock',
    'Sauk',
    'Sheboygan',
    'Walworth',
    'Washington',
    'Waukesha',
    'Waupaca',
    'Wood',
  ].sort(),
  Wyoming: [
    'Big Horn',
    'Hot Springs',
    'Park',
    'Washakie',
    'Fremont',
    'Lincoln',
    'Sublette',
    'Teton',
    'Laramie',
    'Natrona',
    'Campbell',
    'Crook',
    'Johnson',
    'Sheridan',
    'Weston',
    'Albany',
    'Carbon',
    'Converse',
    'Goshen',
    'Niobrara',
    'Platte',
    'Sweetwater',
    'Uinta',
  ].sort(),
};

export default countyData;

export const stateData = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'DC',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
].sort();
